function StationsController(stateService, userService, $state) {
  const ctrl = this;

  ctrl.$onInit = () => {
    let selectedWorkspace = stateService.getSelectedWorkspace();
    ctrl.workspaceId = selectedWorkspace.id;
    ctrl.isLocked = selectedWorkspace.deployable;
    ctrl.workspaceName = selectedWorkspace.name;
    if (!ctrl.workspaceId) $state.go('pis.workspaces');
    ctrl.dataLoading = true;
    stateService.getStations(ctrl.workspaceId).then(data => {
      ctrl.stations = data.stations;
      if (ctrl.stations) {
        // Make single string of variables that is used in search filtering
        ctrl.stations.map(station => {
          station.allVariables = "";
          if (station.variables && station.variables.length > 0) {
            const variables = station.variables.map(function (variable) { return variable.name + "(" + variable.value + ")"; });
            station.allVariables = variables.toString().replaceAll(",", " ");
          }
        });
      }
      ctrl.dataLoading = false;
    });
    ctrl.editMode = false;
    ctrl.hasEdit = userService.hasEditPIS();
  };

  ctrl.onToggleEdit = event => {
    $state.go('pis.workspaces.stations.station', { id: event.station.id });
    ctrl.editMode = event.editMode;
    ctrl.selection = event.station;
  };

  // TODO: Station delete is not implemented in this version
  ctrl.onDelete = event => {
    stateService.deleteStation(ctrl.workspaceId, event.stationId).then(
      response => {
        stateService.getStations(ctrl.workspaceId).then(data => ctrl.stations = data.stations);
        // toasterService.success('toaster.package-upload-event', 'toaster.package-upload-start-success');
      },
      function(e) {
        // toasterService.error('toaster.package-upload-event', 'toaster.package-upload-start-failure');
        console.log(e);
      }
    );
  };

  ctrl.backToList = () => {
    ctrl.editMode = false;
  };

  ctrl.onFormSubmit = event => {
    ctrl.editMode = event.mode;
    stateService.getStations(ctrl.workspaceId).then(data => ctrl.stations = data.stations);
    ctrl.selection = null;
    $state.go('pis.workspaces.stations');
  };

  ctrl.toggleEditor = () => {
    if (ctrl.editMode) {
      ctrl.editMode = false;
      stateService.getStations(ctrl.workspaceId).then(data => ctrl.stations = data.stations);
    } else {
      ctrl.editMode = true;
    }
  };

  ctrl.exportToCsv = () => {
    if (ctrl.stations) {
      let stations = ctrl.stations.sort((a,b) => (a.abbreviation > b.abbreviation) ? 1 : ((b.abbreviation > a.abbreviation) ? -1 : 0))
      let rows = [];
      let titleRow = [];
      titleRow.push("Id", "Name", "Abbreviation", "Variables")
      rows.push(titleRow)
      stations.map(station => {
        let row = [];
        row.push(station.id);
        row.push(station.name);
        row.push(station.abbreviation);
        row.push(station.allVariables);
        rows.push(row); 
      });
      let csvContent = "data:text/csv;charset=utf-8," + rows.map(e => e.join(",")).join("\n");
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      const fileName = ctrl.workspaceName + "_STATIONS.csv"
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
    }
  }


}

angular
  .module('pis-tool.module')
  .controller('StationsController', StationsController);
